import { useTranslation } from "react-i18next";

interface Props {
  label?: string;
}

export function ThinkingIndicator({ label }: Props) {
  const { t } = useTranslation("intelligence");
  const text = label ? `${label}…` : t("tool.thinking");
  return (
    <span
      className="inline-block bg-[length:200%_auto] bg-gradient-to-r from-brand/40 via-brand to-brand/40 bg-clip-text text-sm text-transparent animate-shimmer"
      aria-label={text}
    >
      {text}
    </span>
  );
}
